import type { ClientArgs, ClientInferResponseBody } from '@ts-rest/core';
import type { UseQueryOptions } from '@ts-rest/react-query/v5';

import type { LanguagesContract } from '@packages/contracts';

import { LANGUAGE_QUERY_KEY } from '../query-keys';

type LanguageGetByIdRoute = typeof LanguagesContract['getById'];
type LanguageGetByIdResponse = ClientInferResponseBody<LanguageGetByIdRoute, 200>['result']['language'];

export type LanguageGetByIdQueryOptions = UseQueryOptions<
	LanguageGetByIdRoute,
	ClientArgs,
	LanguageGetByIdResponse
>;

export const createLanguageGetByIdQueryOptions = (languageId?: string): LanguageGetByIdQueryOptions => ({
	enabled:   !!languageId,
	queryData: { params: { languageId: languageId ?? '' } },
	queryKey:  LANGUAGE_QUERY_KEY.detail(languageId ?? 'pending'),

	retry: (failureCount, error) => {
		if ('statusCode' in error && (error.statusCode === 404 || error.statusCode === 400)) return false;

		return failureCount < 3;
	},
	select: res => res.body.result.language,
});
